export default "__VITE_ASSET__IwzqLcGe__"